<template>
  <div class="container-fluid">
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">Televisión</h1>
    </div>
    <div class="card">
      <div class="card-header">
        Mis Servicios
      </div>
      <ul class="list-group">
        <li v-for="servicio in getServicios" :key="servicio.id" class="list-group-item">

          Número de servicio: {{ servicio.id }}<br>
          <small>Tipo de servicio: {{servicio.tipo.nombre}}</small>
        </li>
        <li v-if="getServicios.length == 0" class="list-group-item">No posee servicios de televisión. Contrate uno llamando al 0341 4711242</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  middleware: 'auth',
  layout: 'main-layout',
  metaInfo () {
    return { title: 'Televisión' }
  },
  computed: {
    ...mapGetters({
      servicios: 'auth/servicios'
    }),
    getServicios () {
      const tipo_servicios = [17];
      return this.servicios.filter(servicio => tipo_servicios.indexOf(servicio.tipo.id) != -1)
    }
  },
}
</script>
